// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad7768ec","514":"9cca8a93"}[chunkId] + ".chunk.js";
};